import { removeChatFromArchive, setChatOperationPending } from './actions';
import {
  fetchRemoveFromArchiveDesktop,
  TRemoveFromArchiveDesktopResponse,
} from '../../repositories/chats/v1/remove-from-archive-desktop';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { changeRoute } from '../route';

/**
 * Пытаемся восстановить чат из архива
 */
export const removeFromArchive =
  (chatId: string): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    dispatch(setChatOperationPending(true));

    try {
      const { statusCode, response }: TRemoveFromArchiveDesktopResponse = await fetchRemoveFromArchiveDesktop({
        httpApi,
        parameters: { chatId },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setChatOperationPending(false));

      // @ts-expect-error модель не совпадает с кодом сервера
      if (statusCode === 200 || statusCode === 204) {
        dispatch(removeChatFromArchive(chatId));

        /**
         * При удачном восстановлении чата из архива, переводим пользователя на страницу активных чатов
         */
        dispatch(changeRoute({ route: ERoute.Messages }));
        dispatch(showAlert({ message: 'Чат разархивирован' }));

        return;
      }

      /**
       * При неудачной попытке восстановить чат из архива, показываем алерт с ошибкой
       */
      dispatch(showAlert({ message: response.message || 'Возникла ошибка при попытке перенести чат из архива' }));
    } catch (error) {
      logger.error(error, {
        chatId,
        domain: 'frontend-chats.actions.removeFromArchive',
        description: 'Ошибка при попытке восстановить из архива',
      });

      dispatch(setChatOperationPending(false));
      dispatch(showAlert({}));
    }
  };
